import { render, staticRenderFns } from "./InvoicesCreditNoteNewForm.vue?vue&type=template&id=2f04a0b5"
import script from "./InvoicesCreditNoteNewForm.vue?vue&type=script&lang=js"
export * from "./InvoicesCreditNoteNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports